import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import AlertBox from '../../../components/AlertBox/AlertBox';
import AuthOTPModal from '../../Listing/components/AuthOTPModal';

export class AuthView extends React.Component {
  constructor(props) {
    super(props);
    this.handlechange = this.handlechange.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
    this.setModalState = this.setModalState.bind(this);
    this.state = {
      errorClass: '',
      remember: false,
      btnClass: false,
      termAndConditions: false,
    };
  }

  componentDidMount() {
    let body = document.body;
    body.className = 'user_login';
    if (this.props.ListingState.authModal !== 'login') {
      this.props.setAuthModal('');
    }
    if (localStorage.remember && localStorage.username !== '') {
      this.props.setLoginData({
        username: localStorage.getItem('username'),
        password: localStorage.getItem('password'),
      });
    }
    if (window.location.href.split('/')[3] === 'counsellor') {
      let { email_id, id } = this.props.match.params;
      if (email_id && id) {
        this.props.BridgeLogin({
          data: this.props.match.params,
          history: this.props.history,
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.setLoginData({ username: '', password: '' });
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  setModalState(value) {
    this.setState({ modal: value });
  }

  handlechange(event) {
    let { loginData } = this.props.auth;
    const name = event.target.name;
    const value = event.target.value;
    if (event.target.type === 'checkbox') {
      this.setState({ remember: event.target.checked });
    } else {
      loginData[name] = value;
      this.props.setLoginData(loginData);
    }
  }

  submitHandler(event) {
    event.preventDefault();
    let { loginData } = this.props.auth;
    let regex = /^([_\-\.0-9a-zA-Z]+)@([_\-\.0-9a-zA-Z]+)\.([a-zA-Z]){2,7}$/;
    const { remember, termAndConditions } = this.state;
    if (!loginData.username.trim().length && !loginData.password.length) {
      this.props.setErrLoginMessage({
        message: 'Email-address and password fields are required',
        color: 'teal',
      });
      this.setState({ errorClass: 'username' });
    } else if (!loginData.username.trim().length) {
      this.props.setErrLoginMessage({
        message: 'Email field is required.',
        color: 'teal',
      });
      this.setState({ errorClass: 'username' });
    } else if (!regex.test(loginData.username.trim())) {
      this.props.setErrLoginMessage({
        message: 'Enter a valid Email.',
        color: 'teal',
      });
      this.setState({ errorClass: 'username' });
    } else if (!loginData.password.length) {
      this.props.setErrLoginMessage({
        message: 'Password field is required.',
        color: 'teal',
      });
      this.setState({ errorClass: 'password' });
    } else {
      if (remember) {
        localStorage.setItem('username', loginData.username);
        localStorage.setItem('password', loginData.password);
        localStorage.setItem('remember', remember);
      }
      this.props.logIn({ ...loginData, history: this.props.history });
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      this.props.setErrLoginMessage({ message: '', color: '' });
      this.setState({ errorClass: '' });
    }, 3000);
  }

  render() {
    const { errLoginMessage, logInSpinnerstatus, loginData } = this.props.auth;
    const { errSignupMessage } = this.props.Signup;
    const { authModal } = this.props.ListingState;
    let { errorClass, termAndConditions } = this.state;
    let urlPath =
      this.props && this.props.location && this.props.location.pathname
        ? this.props.location.pathname
        : '';
    return (
      <Fragment>
        {
          <div
            className={
              authModal === 'login'
                ? 'login_form w-full bg-white p-4 text-center'
                : 'login_form md:w-1/2 bg-white p-4 text-center'
            }
          >
            {/* @@ cancel and redirect to home page */}
            <div    onClick={() => this.props.setAuthModal("")} style={{ position: 'relative', textAlign: "right", fontWeight: "600", cursor: 'pointer', fontSize: '1.2rem' }}>
              <Link to="/" >
                <img style={{ position: 'absolute', top: '0', right: '0', height: '20px' }} src='/images/close_blue.svg' />
              </Link>
            </div>

            {errSignupMessage.message ? (
              <AlertBox
                AlertText={errSignupMessage.message}
                color={errSignupMessage.color}
              />
            ) : null}
            {errLoginMessage.message ? (
              <AlertBox
                AlertText={errLoginMessage.message}
                color={errLoginMessage.color}
              />
            ) : null}
            {authModal === 'OTP' ? (
              <AuthOTPModal
                cancelEvent={() => this.props.setAuthModal('')}
                history={this.props.history}
              />
            ) : null}
            <div className="site__logo w-24 m-auto">
              <Link to="/">
                <img
                  className="w-full"
                  src="images/new-web-logo.png"
                  alt="Site Logo"
                />
                <span>Coacherly</span>
              </Link>
            </div>
            <div className="main_forms">
              <form
                className="login_form"
                onSubmit={(e) => this.submitHandler(e)}
              >
                <div className="form_title font-bold">
                  <h3>Login</h3>
                </div>
                <div className="form-item">
                  <label>Email Address</label>
                  <input
                    className={errorClass == 'username' ? 'border-red-500' : ''}
                    type="text"
                    name="username"
                    onChange={this.handlechange}
                    value={loginData.username}
                  />
                  {errorClass == 'username' ? (
                    <p className="err-message">{errLoginMessage.message}</p>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-item">
                  <label>Password</label>
                  <input
                    className={errorClass == 'password' ? 'border-red-500' : ''}
                    type="password"
                    name="password"
                    onChange={this.handlechange}
                    value={loginData.password}
                  />
                  {errorClass == 'password' ? (
                    <p className="err-message">{errLoginMessage.message}</p>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-item form-item--checkbox">
                  <input
                    id="remember"
                    type="checkbox"
                    onChange={this.handlechange}
                  />
                  <label htmlFor="remember">Remember Me</label>
                </div>
                <div className="form-actions">
                  <button type="submit">
                    {logInSpinnerstatus ? <LoadingSpinner /> : 'Submit'}
                  </button>
                </div>
                <div className="gridBlockTwo">
                  <div className="form-actions">
                    <Link
                      to="/coach/login"
                      className={`${
                        urlPath == '/coach/login' ? 'btnBlue active' : 'btnBlue'
                        }`}
                    >
                      Coach Login
                    </Link>
                    {/* <button type="submit">Login as Coach</button> */}
                  </div>
                  <div className="form-actions">
                    <Link
                      to="/user/login"
                      className={`${
                        urlPath == '/user/login' ? 'btnBlue active' : 'btnBlue'
                        }`}
                    >
                      Client Login
                    </Link>
                    {/* <button type="submit">Login as User</button> */}
                  </div>
                </div>
              </form>
              {authModal !== 'login' ? (
                <div className="forget_pwd">
                  {window.location.href.split('/')[3] == 'user' ? (
                    <Fragment>
                      {' '}
                      Don't have an Account{' '}
                      <Link className="text_nav_blue" to="/user/signup">
                        SignUp here!
                      </Link>
                      <br />
                    </Fragment>
                  ) : null}
                  <Link
                    to="/user/forgot-password"
                    className="modal-open text_nav_blue"
                  >
                    Forgot Password?
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
        }
        {/* {authModal === '' ? (
          <div className="welcome_note text-white text-center md:w-1/2 p-6 md:px-8 lg:px-16">
            <div className="form_text--title">
            </div>
            <div className="login__text">
              <p>
              Coacherly online coaching software was created specifically to help those who suffer from addiction.
              </p>
              <p>
              Our team has many decades of experiential knowledge in addiction recovery, coaching, counseling, sober living, and treatment.
              </p>
              <p>
              Here are some articles written by experts for you! Please take some time to read and share, thank you!
              </p>
            </div>
            <div className="btn login_text--btn">
              {window.location.pathname.slice(0, 5) === '/user' ? (
                <Link to="/coach/login">Login as Coach</Link>
              ) : (
                <Link to="/user/login">Login as User</Link>
              )}
            </div>
          </div>
        ) : null} */}
      </Fragment>
    );
  }
}

// AuthView.propTypes = {
//   history: PropTypes.object.isRequired,
//   auth: PropTypes.object.isRequired,
//   logIn: PropTypes.func.isRequired,
//   setErrLoginMessage: PropTypes.func.isRequired,
// };

export default AuthView;



// WEBPACK FOOTER //
// ./src/routes/login/components/AuthView.js